import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import React, { useMemo } from 'react';
import useDatasource from '../../../../hooks/useDatasource';
import {
  deleteCouncilDecision,
  searchCouncilDecisions,
} from '../../../../services/taxonomies/council-decision';
import Column from '../../../../helpers/columns';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import { Default } from '../../../../layouts';
import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const CouncilDecisionList = () => {
  const { t } = useTranslation();

  const { pagination, content, handleChange, reload } = useDatasource(
    searchCouncilDecisions,
  );

  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.councilDecision.name'), {
        filter: true,
      }),
      Column.date('startDate', t('entity.taxonomy.councilDecision.startDate'), {
        filter: true,
        format: 'YYYY-MM-DD',
      }),
      Column.bool('deleted', t('entity.taxonomy.councilDecision.deleted._'), {
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.councilDecision.deleted.true'),
          t('entity.taxonomy.councilDecision.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (councilDecision) => (
        <>
          {canView && (
            <ViewItemIcon
              path={`/admin/taxonomies/council-decisions/${councilDecision.id}`}
            />
          )}
          {canEdit && (
            <EditItemIcon
              path={`/admin/taxonomies/council-decisions/${councilDecision.id}`}
            />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t(
                'entity.taxonomy.councilDecision._delete',
                councilDecision,
              )}
              message={t(
                'entity.taxonomy.councilDecision._deleted',
                councilDecision,
              )}
              item={councilDecision}
              action={deleteCouncilDecision}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.councilDecision._plural')}>
        <AddEntityButton
          entity={t('entity.taxonomy.councilDecision._singular')}
          path="/admin/taxonomies/council-decisions/new"
        />
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        scroll={{ x: 700, y: 700 }}
        onChange={handleChange}
      />
    </Default>
  );
};

export default CouncilDecisionList;
